import { render, staticRenderFns } from "./sp-video.vue?vue&type=template&id=73001902"
import script from "./sp-video.vue?vue&type=script&lang=js"
export * from "./sp-video.vue?vue&type=script&lang=js"
import style0 from "./sp-video.vue?vue&type=style&index=0&id=73001902&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports